import { gql } from '@apollo/client'

export const favoriteVisibilityFragment = gql`
  fragment VisibilityFavoriteBook on BookAsNode {
    favoritesVisibility @client
  }
`
